<section id="contact" class="contact-section py-24 relative overflow-hidden">
  <p-toast />
  <div class="contact-bg"></div>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
    <!-- Header -->
    <div class="text-center mb-16">
      <span class="section-badge">Get In Touch</span>
      <h2 class="text-4xl sm:text-5xl font-bold mt-4 mb-4">
        Let's Build Something <span class="gradient-text">Great</span>
      </h2>
      <p class="text-slate-600 max-w-xl mx-auto">
        Have a project in mind? Tell us about it — we’ll get back to you soon.
      </p>
      <div class="section-underline"></div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-5 gap-10">
      <!-- Contact Info -->
      <div class="lg:col-span-2 flex flex-col gap-6">
        @for (info of contactInfo; track info.label) {
          <div class="contact-info-card">
            <div class="info-icon">
              <i class="pi" [class]="info.icon"></i>
            </div>
            <div>
              <div class="info-label">{{ info.label }}</div>
              @if (info.href) {
                <a [href]="info.href" class="info-value hover:text-[var(--color-primary)] transition-colors">{{ info.value }}</a>
              } @else {
                <span class="info-value">{{ info.value }}</span>
              }
            </div>
          </div>
        }

        <!-- Why Choose Us -->
        <div class="why-card">
          <h4 class="font-semibold text-slate-900 mb-4">Why partner with Trieon Technologies?</h4>
          <ul class="space-y-3">
            @for (item of ['End-to-end product delivery', 'Web, mobile, and backend under one team', 'Real systems already in production']; track item) {
              <li class="flex items-center gap-3 text-sm text-slate-600">
                <i class="pi pi-check-circle text-green-600 text-base"></i>
                {{ item }}
              </li>
            }
          </ul>
        </div>
      </div>

      <!-- Contact Form -->
      <div class="lg:col-span-3">
        <div class="contact-form-card">
          @if (submitted()) {
            <div class="success-state">
              <div class="success-icon">
                <i class="pi pi-check text-3xl text-green-600"></i>
              </div>
              <h3 class="text-2xl font-bold text-slate-900 mb-2">Ready to send</h3>
              <p class="text-slate-600">Your email draft should be open. Send it when you’re ready, or write another message below.</p>
              <button class="mt-6 px-6 py-2 rounded-lg text-sm text-[var(--color-primary-dark)] border border-[rgba(15,139,141,0.35)] hover:bg-[rgba(15,139,141,0.08)] transition-colors" (click)="submitted.set(false)">
                Send Another Message
              </button>
            </div>
          } @else {
            <form (ngSubmit)="onSubmit()" #contactForm="ngForm">
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                <div class="form-field">
                  <label>Full Name *</label>
                  <input pInputText [(ngModel)]="form.name" name="name" placeholder="John Doe" required class="w-full" />
                </div>
                <div class="form-field">
                  <label>Email Address *</label>
                  <input pInputText [(ngModel)]="form.email" name="email" type="email" placeholder="john@company.com" required class="w-full" />
                </div>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                <div class="form-field">
                  <label>Company</label>
                  <input pInputText [(ngModel)]="form.company" name="company" placeholder="Your Company" class="w-full" />
                </div>
                <div class="form-field">
                  <label>Service Interested In</label>
                  <p-select
                    [(ngModel)]="form.service"
                    name="service"
                    [options]="serviceOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select a service"
                    class="w-full"
                    styleClass="w-full"
                  />
                </div>
              </div>
              <div class="form-field mb-6">
                <label>Your Message *</label>
                <textarea
                  pTextarea
                  [(ngModel)]="form.message"
                  name="message"
                  placeholder="Tell us about your project, goals, timeline..."
                  rows="5"
                  required
                  class="w-full"
                ></textarea>
              </div>
              <button
                type="submit"
                class="submit-btn w-full flex items-center justify-center gap-3 py-4 px-8 rounded-xl font-semibold text-white text-base"
                [disabled]="submitting()"
              >
                @if (submitting()) {
                  <i class="pi pi-spin pi-spinner"></i>
                  Sending...
                } @else {
                  <i class="pi pi-send"></i>
                  Send Message
                }
              </button>
            </form>
          }
        </div>
      </div>
    </div>
  </div>
</section>

